export const MASTER = 'MASTER';
export const COMPANY = 'COMPANY';
export const STAFF = 'STAFF';
export const DRIVER = 'DRIVER';
export const RESELLER = 'RESELLER';
export const FLEET_MANAGEMENT = 'FLEET_MANAGEMENT';
